import { gql } from "@apollo/client";
import { useQuery } from "../_api/hooks";

export const GET_USER_IS_ADMIN = gql`
  query getUserIsAdmin {
    User {
      Id
      IsAdmin
    }
  }
`;

/** True when the signed-in user has the Auth0 "Admin" role. Only decides what the menu shows. */
export const useIsAdmin = () => {
  const { data, loading } = useQuery(GET_USER_IS_ADMIN, { fetchPolicy: "cache-first" });
  return { isAdmin: data?.User?.IsAdmin === true, loading };
};
